import React from "react";
import NewsFlashBanner from "@/pages/admin/newsflash/NewsFlashBanner";
import Navbar from "./Navbar";

const Header = () => {
  return (
    <>
      <NewsFlashBanner />
      <Navbar/>
    </>
  );
};

export default Header;
